import Image from '@/components/UI/Image';
import { useGlobal } from '@/utils/useGlobal';
import { useMemo } from 'react';
export default function SeriesType({ initData, router }: any) {
    const { isMobile } = useGlobal();
    const Dom = useMemo(() => {
        const homeGoDetail = (url: string) => {
            if (url) {
                router.push(url);
            }
        };
        return (
            <>
                <div className="product-list">
                    <ul>
                        {initData?.map((item: any) => (
                            <li className="ft0" key={item.id} onClick={() => homeGoDetail(JSON.parse(item.buttonText)[0]?.buttonUrl)}>
                                {item.phonePictureUrl && isMobile && (
                                    <div className="list-img-box">
                                        <Image src={item.phonePictureUrl} className="fullImgs" layout="fill" alt={item.mainHeading}></Image>
                                    </div>
                                )}
                                {item.webPictureUrl && !isMobile && (
                                    <div className="list-img-box">
                                        <Image src={item.webPictureUrl} className="fullImgs" layout="fill" alt={item.mainHeading}></Image>
                                    </div>
                                )}

                                <div className="box">
                                    {/* <ScrollAnimation animateIn='fadeInLeft' animateOut='fadeInRight'> */}
                                    <h2
                                        style={{
                                            color: item.textColor === 'white' ? '#fff' : '#000',
                                        }}
                                        className="title font-family-bold"
                                    >
                                        {item.mainHeading}
                                    </h2>
                                    <p
                                        style={{
                                            color: item.textColor === 'white' ? '#fff' : '#000',
                                        }}
                                        className="des"
                                    >
                                        {item.subHeading}
                                    </p>
                                    {JSON.parse(item.buttonText)[0]?.buttonName && (
                                        <span className="msg-linkitem ef-icon-arrowright" style={{ color: item.btnColor }} aria-label={item.mainHeading}>
                                            {JSON.parse(item.buttonText)[0].buttonName}
                                        </span>
                                    )}
                                    {/* </ScrollAnimation> */}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </>
        );
    }, [Image, initData, isMobile, router]);

    return <>{Dom}</>;
}
